module.exports = __webpack_public_path__ + "static/media/2.c89f69ad.png";